<template>
  <div class="mnp-common-brands">
    <div class="headline"><slot name="headline"></slot></div>
    <div class="filters outline">
      <button type="button" v-for="(brand, index) in brands" :key="index" :id="'mnp-data-common-brand-' + (index + 1)" @click="selectBrand(brand)">
        {{ brand }}
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CommonBrands',
  props: {
    numberOfBrands: {
      type: Number,
      default: 5
    }
  },
  computed: {
    brands () {
      return Array.from({ length: this.numberOfBrands }, (_, i) => this.getBrandName(i + 1))
    }
  },
  methods: {
    getBrandName (suffix) {
      const slotName = `txtBrand${suffix}`
      return this.$slots[slotName] && this.$slots[slotName][0] ? this.$slots[slotName][0].text : null
    },
    selectBrand (brand) {
      if (brand) {
        this.$emit('selected', brand)
      }
    }
  }
}
</script>
